const searchQueryKeys = {
  SEARCH_DETAIL: ['SEARCH_DETAIL'] as const,
  SEARCH_RESULT: ['SEARCH_RESULT'] as const,
  SEARCH_HISTORY_LIST: ['SEARCH_HISTORY_LIST'] as const,
  SEARCH_RESULT_ACCOUNTS: ['SEARCH_RESULT_ACCOUNTS'] as const,
  SEARCH_RESULT_ACCOUNT_DIST: ['SEARCH_RESULT_ACCOUNT_DIST'] as const,
  SEARCH_RESULT_TAGS: ['SEARCH_RESULT_TAGS'] as const,
  SEARCH_RESULT_FEEDBACK_LIST: ['SEARCH_RESULT_FEEDBACK_LIST'] as const,
  SEARCH_RESULT_FEEDBACK_TREND: ['SEARCH_RESULT_FEEDBACK_TREND'] as const,
  SEARCH_RESULT_FEEDBACK_SENTIMENT_DIST:
    ['SEARCH_RESULT_FEEDBACK_SENTIMENT_DIST'] as const,
  SEARCH_RESULT_CUSTOMER_TREND: ['SEARCH_RESULT_CUSTOMER_TREND'] as const,
  SEARCH_SUMMARY_ISSUE_FEEDBACK_LIST: ['SEARCH_SUMMARY_ISSUE_FEEDBACK_LIST'] as const,
  SEARCH_RESULT_AGENTS: ['SEARCH_RESULT_AGENTS'] as const,
};

export default searchQueryKeys;
